import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../actions/authActions';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(s => s.auth);
  const [form, setForm] = useState({ email: '', password: '' });

  const submit = async (e) => {
    e.preventDefault();
    const res = await dispatch(login(form.email, form.password));
    if (res.ok) navigate('/dashboard');
  };

  return (
    <section className="section narrow">
      <h1>Sign in</h1>
      <form className="auth-form" onSubmit={submit}>
        <label>Email<input required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></label>
        <label>Password<input required type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} /></label>
        <button className="btn-primary" type="submit" disabled={loading}>{loading ? 'Signing in…' : 'Sign in'}</button>
        {error && <p className="status error">{error}</p>}
      </form>
      <p className="muted">No account? <Link to="/signup">Sign up</Link> &middot; <Link to="/forgot-password">Forgot password?</Link></p>
    </section>
  );
}
